import axios from "axios";

export const sendMail = (formData, content) => {
  const {
    REACT_APP_API_BASE_URL,
    REACT_APP_EMAIL_RECEIVER,
    REACT_APP_PARTY_ID,
  } = process.env;
  const { name, phone, email, notes } = formData;

  return axios.post(
    `${REACT_APP_API_BASE_URL}/api/emails`,
    {
      type: "contact_us",
      sender: email,
      receiver: REACT_APP_EMAIL_RECEIVER,
      subject: `[BookingCampus] Contact Us`,
      content: content || notes,
      metadata: {
        customer_email: email,
        customer_name: name,
        customer_phone_number: phone,
        customer_note: notes,
      },
      party_id: REACT_APP_PARTY_ID,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};
